import { CalendatNewFile } from '../calendar/calendar-new';

let CalendarInstance: CalendatNewFile;

CalendarInstance = new CalendatNewFile();

export { CalendarInstance };